import { memo } from "react";
import { Button } from "@narmi/design_system";
import { useLocalization } from "@fluent/react";

import styles from "./DashboardCustomization.module.scss";
import { useDashboardCustomizationContext } from "../DashboardCustomizationContext";

const DashboardButton = () => {
  const { l10n } = useLocalization();
  const { openDialogHandler } = useDashboardCustomizationContext();
  return (
    <div className={styles["dashboard-button-wrapper"]}>
      <Button
        kind="tertiary"
        onClick={openDialogHandler}
        label={l10n.getString("dashboard-customization-title", null)}
      />
    </div>
  );
};

export default memo(DashboardButton);
